import { ApiResponse } from '@/modules/common/types/dto/response/api-response';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';
import { BaseOnboardingEntity } from '@/modules/onboarding/common/types/base-onboarding-entity';

export enum ClientDataReconciliationQueryKeys {
  Clients = 'clients-data-reconciliation',
  ValidationReport = 'clients-validation-report',
}

export interface Client extends BaseOnboardingEntity {}

export interface ClientsApiData extends PaginatedResponse<Client> {}

export class ClientsApiResponse extends ApiResponse<ClientsApiData> {}
